

















































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { routeName } from '@/constants/route.constants';
import DisplayOwnerDetailsComponent from '@/components/public/display-owner-details.component.vue';
import { REGISTERED_TAG_MODULE_NAME } from '@/store/modules/registered-tag.module';
import { mapState } from 'vuex';
import { RegisteredTag } from '@/models/DTO/registered-tag/registered-tag.model';
import PublicCancelMixin from '@/mixins/public-cancel.mixin';

@Component({
  components: {
    DisplayOwnerDetailsComponent
  },
  computed: {
    ...mapState(REGISTERED_TAG_MODULE_NAME, ['currentRegisteredTag'])
  }
})
export default class OwnerDetailsComponent extends mixins(PublicCancelMixin) {
  public currentRegisteredTag: RegisteredTag | null;

  public onUpdateOwnerClick() {
    this.$router.replace({ name: routeName.public.customerAccess });
  }

  public onCancelClick() {
    this.onCancel();
  }
}
